import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { logoutUser } from '../../actions/user';
import { fetchMenuData, triggerFolderReload } from '../../actions/sidemenu';
import CLIENT_VERSION from '../../constants/Version';
import './Menu.css';

const Menu = ({
    refreshAccessToken = () => {},
    fetchUserData,
    user,
    menuData,
    isFetching,
    fetchSystemInfo,
    systemInfo,
    fetchWhatNewData
}) => {

    const isDisabled = useSelector(state =>
        state.documentsearchbar?.isFetching ||
        state.datafolder?.isFetching ||
        state.datafolder?.isFetchingCount ||
        state.detailsearch?.isFetching
    );

    // const [openMenus, setOpenMenus] = useState(() => {
    //     const saved = sessionStorage.getItem('openMenus');
    //     return saved ? JSON.parse(saved) : [];
    // });
    const [openMenus, setOpenMenus] = useState([]);
    const [activeFolder, setActiveFolder] = useState(null);
    const [activeDept, setActiveDept] = useState(null);
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const match = location.pathname.match(/^\/department\/([^/]+)(?:\/folder\/([^/]+))?/);
    const deptId = match?.[1];
    const folderId = match?.[2];

    useEffect(() => {
        setActiveDept(deptId || null);
        setActiveFolder(folderId || null);
    }, [deptId, folderId]);


    useEffect(() => {
        if (location.pathname === '/') {
            setActiveDept(null);
            setActiveFolder(null);
            // setOpenMenus([]);
        }
    }, [location.pathname]);

    useEffect(() => {
        fetchUserData();
        fetchWhatNewData();
    }, [fetchUserData, fetchWhatNewData]);

    /* 初回のみ system info 取得 */
    const isInitialRender = useRef(true);
    useEffect(() => {
        let accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');

        if (accessToken && refreshToken) {
            // Call fetchSystemInfo on the first render
            if (isInitialRender.current) {
                fetchSystemInfo();
                isInitialRender.current = false;
            }
        }

    }, [fetchSystemInfo]);

    /* メニュー取得 */
    const token = localStorage.getItem('accessToken');
    useEffect(() => {
        if (!token) return;  
        
        const fetchData = async () => {
            try {
                await dispatch(fetchMenuData());
            } catch (error) {
                console.error('Error fetching menu data:', error);
            }
        };
    
        fetchData();
    }, [token, dispatch]); 

    /* ===============================
       メニュー取得後、全展開
       =============================== */
    useEffect(() => {
        if (!menuData || menuData.length === 0) return;

        const allDeptIds = menuData.map(d => d.department_id);
        setOpenMenus(allDeptIds);
    }, [menuData]);

    // useEffect(() => {
    //     sessionStorage.setItem('openMenus', JSON.stringify(openMenus));
    // }, [openMenus]);

    useEffect(() => {
        if (!deptId || !folderId) return;

        setOpenMenus(prev => {
            if (prev.includes(deptId)) return prev;
            return [...prev, deptId];
        });
    }, [deptId, folderId]);

    const handleLogoClickBack = () => {
        navigate('/', { state: { resetDashboard: Date.now() } });

        setActiveDept(null);
        setActiveFolder(null);
        // setOpenMenus([]);
        sessionStorage.removeItem('openMenus');
    };

    // ログアウト処理：Reduxの状態を初期化し、ログイン画面へ戻る
    const handleLogout = () => {
        dispatch(logoutUser());
    };

    if (isFetching) return (
        <div className="menu-load">
            <div className="spinner"></div>
        </div>
    );

    const toggleMenu = (deptId) => {
        // setOpenMenus(prev => {
        //     return prev.includes(deptId)
        //         ? prev.filter(id => id !== deptId)
        //         : [...prev, deptId];
        // });
    };

    const handleDeptClick = (deptId) => {
        console.log('Menu.jsx/handleDeptClick() - deptId:', deptId);
        setActiveDept(deptId);
        setActiveFolder(null);

        navigate(`/department/${deptId}`, { state: { forceReload: Date.now() } });

        dispatch({ type: "CLEAR_DATA_FOLDER" });
    };

    const handleMenuClick = (folderId, deptId) => {
        console.log('Menu.jsx/handleMenuClick() - folderId:', folderId, 'deptId:', deptId);
        
        dispatch(triggerFolderReload());

        setActiveDept(deptId);
        setActiveFolder(folderId);

        navigate(`/department/${deptId}/folder/${folderId}`, { state: { forceReload: Date.now() } });
    };


    return (
        <>
            <div className="ajax-sidemenu">
                <div className='lay-sidemenu'>
                    <div className="lay-sidemenu-wrap">
                        <div className="lay-sidemenu__logo" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer'}}>
                            <img className="menuIcon" src="/img/common/navi/logo.png" alt="Logo"
                                onClick={() => {
                                    if (isDisabled) return;
                                    handleLogoClickBack();
                                }} 
                                style={{cursor: 'pointer'}}/>
                            <div style={{fontSize: '18px', fontWeight: '700'}}>発番システム</div>
                        </div>

                        <div className="side-menu-list">
                            {menuData && menuData.map((dept) => {
                                const isOpen = openMenus.includes(dept.department_id);
                                return (
                                    <div key={dept.department_id} className="menu-section">
                                        <div
                                            className={`menu-dept-name ${activeDept === dept.department_id ? 'active-dept' : ''}`}
                                            disabled={isDisabled}
                                                onClick={() => {
                                                    if (isDisabled) return; 
                                                    handleDeptClick(dept.department_id);
                                                }}
                                        >
                                            {/* <div className={`ac-link ${isOpen ? 'clicked' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleMenu(dept.department_id); 
                                                }}
                                            ></div> */}
                                            <div className="ac-link clicked"></div>
                                            {dept.department_name}
                                        </div>

                                        <ul style={{
                                            maxHeight: isOpen ? '500px' : '0',
                                            overflow: 'hidden',
                                            transition: 'max-height 0.4s ease'
                                        }}>
                                            {dept.folder.map((item) => (
                                                <li
                                                    key={item.folder_id}
                                                    className={activeFolder === item.folder_id ? 'active-folder' : ''}
                                                        onClick={() => {
                                                            if (isDisabled) return;
                                                            handleMenuClick(item.folder_id, dept.department_id);
                                                        }}
                                                >
                                                    {item.folder_name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Footer Menu */}
                        <div className="lay-sidemenu-footer" style={{marginTop: 'auto'}}>
                            <div className="lay-sidemenu__logout" style={{textAlign: 'center', marginBottom: '10px'}}>
                                <button className="logout-button" onClick={handleLogout}>ログアウト</button>
                            </div>
                            <div className="lay-sidemenu__copyright">
                                <img src="/img/common/navi/copyright.png" alt="Hakaru+ Copyright(C) HAKARU PLUS Corporation. All Rights Reserved." />
                            </div>
                            <div className="lay-bottom__title">
                                <div className="footer-version">
                                    <div>Version {CLIENT_VERSION}</div>
                                    <span>&nbsp;&mdash;&nbsp;</span>
                                    {systemInfo?.version && (
                                        <div>API Version {systemInfo.version}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default React.memo(Menu);
